<div class="fixed inset-0 bg-gray-700 bg-opacity-75 flex justify-center items-center z-20">
    <div class="bg-white shadow-lg rounded p-4 max-w-md w-full relative">
        <h1 class="font-bold text-xl">{{title}}</h1>
        <p class="mt-1 mb-4 text-primary-300 text-sm">{{description}}</p>

        @let working = (isWorking$ | async) ?? false;

        @for (item of students; track item.memberId) {
        @let studentAttendance = (updateAttendance[item.memberId] && updateAttendance[item.memberId].attendanceStatus)
        ||
        (currAttendance.get(item.memberId)?.attendanceStatus ?? attendanceStatus.absent);
        <div (click)="onToggled(item)" class="cursor-pointer flex flex-col mb-1 w-full">
            @let unmarked = studentAttendance == attendanceStatus.unmarked;
            <div
                class="{{ working ? 'bg-gray-100' : unmarked ? 'bg-gray-200' : studentAttendance == attendanceStatus.present ? 'bg-green-200' : 'bg-red-200' }} flex flex-row justify-between p-4">
                <p class="cursor-pointer text-sm font-semibold">{{item.name}}</p>
                <p
                    class="cursor-pointer text-sm font-semibold flex items-center capitalize {{ working ? 'bg-primary-400' : unmarked ? 'text-gray-600' : studentAttendance == attendanceStatus.present ? 'text-green-700' : 'text-red-600' }}">
                    {{ unmarked ? 'not marked' : (studentAttendance ?? attendanceStatus.absent) }}</p>
            </div>
        </div>
        } @empty {
        @if(working) {
        <app-loading-box [rows]="3"></app-loading-box>
        } @else {
        <div class="flex flex-col p-2 w-full">
            <p class="text-sm text-primary-300 text-center font-semibold">No students found</p>
        </div>
        }
        }

        <div class="mt-4 flex flex-row gap-4 justify-end">
            <button type="button" (click)="onCancel()"
                class="text-primary-500 px-4 py-2 focus:outline-none">Cancel</button>
            <app-btn-action [inProgress]="(isWorking$ | async) ?? false" (clicked)="submit()" [label]="action"
                bgColor="bg-primary-500 hover:bg-primary-400 active:bg-secondary-500"></app-btn-action>
        </div>
    </div>
</div>